var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkersPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3859 9.77686H6.67923C3.10194 9.78056 0.202871 12.6796 0.199219 16.2569V17.717C0.202871 19.2213 1.42151 20.44 2.92589 20.4436H12.1393C13.6437 20.44 14.8623 19.2213 14.866 17.717V16.2569C14.8623 12.6796 11.9632 9.78056 8.3859 9.77686ZM13.5326 17.717C13.529 18.4849 12.9073 19.1066 12.1393 19.1103H2.92589C2.15789 19.1066 1.53622 18.4849 1.53256 17.717V16.2569C1.53256 13.4145 3.83683 11.1102 6.67928 11.1102H8.38596C11.2284 11.1102 13.5327 13.4145 13.5327 16.2569V17.717H13.5326Z",
    fill: "#041967"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53063 9.11057C9.92387 9.11057 11.864 7.17044 11.864 4.77721C11.864 2.38398 9.92387 0.443848 7.53063 0.443848C5.1374 0.443848 3.19727 2.38398 3.19727 4.77721C3.20092 7.16895 5.13888 9.10691 7.53063 9.11057ZM7.53063 1.77719C9.18749 1.77719 10.5306 3.12035 10.5306 4.77721C10.5306 6.43406 9.18749 7.77722 7.53063 7.77722C5.87378 7.77722 4.53061 6.43406 4.53061 4.77721C4.53427 3.12184 5.87526 1.78085 7.53063 1.77719Z",
    fill: "#041967"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkersPrimary);
export default __webpack_public_path__ + "static/media/workers_primary.8fcd4d5582ceed320d465e8edef7b43b.svg";
export { ForwardRef as ReactComponent };